import "./Button.scss";

const Button = ({
    children,
    variant = "filled",
    disabled = false,
    loading = false,
    fullWidth = false,
    iconOnly = false,
    iconAlign = "left",
    componentType = "button",
    type = "button",
    href = "",
    to = "",
    target = "_self",
    className = "",
    onClick,
    startIcon,
    endIcon,
    ...props
}) => {
    const buttonClasses = [
        "button",
        `button--${variant}`,
        disabled && "button--disabled",
        loading && "button--loading",
        fullWidth && "button--full-width",
        iconOnly && "button--icon-only",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const handleClick = (event) => {
        if (disabled || loading) {
            event.preventDefault();
            return;
        }

        if (onClick) {
            onClick(event);
        }
    };

    const content = (
        <>
            {loading && (
                <span className="button__spinner">
                    <svg
                        className="button__spinner-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <circle
                            className="button__spinner-circle"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="button__spinner-path"
                            fill="currentColor"
                            d="m12 2 A 10 10 0 0 1 22 12 h -4 A 6 6 0 0 0 12 6 V 2 z"
                        />
                    </svg>
                </span>
            )}

            {!loading && iconAlign === "left" && (startIcon || endIcon) && (
                <span className="button__icon button__icon--start">
                    {startIcon || endIcon}
                </span>
            )}

            {!iconOnly && <span className="button__content">{children}</span>}

            {!loading && iconAlign === "right" && (startIcon || endIcon) && (
                <span className="button__icon button__icon--end">
                    {endIcon || startIcon}
                </span>
            )}
        </>
    );

    if (componentType === "link") {
        return (
            <a
                className={buttonClasses}
                href={href}
                target={target}
                onClick={handleClick}
                {...props}
            >
                {content}
            </a>
        );
    }

    return (
        <button
            className={buttonClasses}
            type={type}
            disabled={disabled || loading}
            onClick={handleClick}
            {...props}
        >
            {content}
        </button>
    );
};

export default Button;
